import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgChevronUp = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M18.7803 15.2803C19.0732 14.9874 19.0732 14.5126 18.7803 14.2197L12.5303 7.96967C12.2374 7.67678 11.7626 7.67678 11.4697 7.96967L5.21967 14.2197C4.92678 14.5126 4.92678 14.9874 5.21967 15.2803C5.51256 15.5732 5.98744 15.5732 6.28033 15.2803L12 9.56066L17.7197 15.2803C18.0126 15.5732 18.4874 15.5732 18.7803 15.2803Z",
		fill: "var(--colors-grey-1)"
	})
});
export default SvgChevronUp;
